// extracted by mini-css-extract-plugin
export var burgerized = "LanguageSelectorStyle-module--burgerized--e93cb";
export var container = "LanguageSelectorStyle-module--container--8e131";
export var languageSelector = "LanguageSelectorStyle-module--languageSelector--132d6";